import type { ButtonColor } from './colors';

export const tertiaryColors: Partial<Record<ButtonColor, string>> = {
  brand: 'text-brand-primary-700 hover:bg-brand-primary-50',
  gray: 'text-text-secondary-600 hover:bg-text-secondary-100',
  white: 'text-text-inverse focus-visible:ring-white focus-visible:ring-offset-black hover:bg-white/10',
};
